var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPolicyViewArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 6,
    viewBox: "0 0 6 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.816286 5.81628L4.66118 1.97143L4.66526 4L5.81628 4L5.81628 0L1.81629 -3.49691e-07L1.81629 1.15102L3.84486 1.1551L1.97872e-06 4.99994L0.816286 5.81628Z",
    fill: "#22034F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolicyViewArrow);
export default __webpack_public_path__ + "static/media/policy-view-arrow.5944ebde439c53ae8b940c7a78de0d12.svg";
export { ForwardRef as ReactComponent };